import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import ErrorContext from "../../context/ErrorContext";
import { setSelectedTissue } from "../../actions/tissues";

export const TissueLoader = ({ Component }) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { setError } = useContext(ErrorContext);
  const [loaded, setLoaded] = useState(false);

  const user = useSelector((state) => state.users.newUser);
  const tissueList = useSelector((state) => state.tissues.tissueList);
  const selectedTissue = useSelector((state) => state.tissues.selectedTissue);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        if (selectedTissue && selectedTissue.id === id) {
          setLoaded(true);
        } else {
          await dispatch(setSelectedTissue(Number(id), tissueList));
          if (isMounted) {
            setLoaded(true);
          }
        }
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setError(error);
        }
      }
    };

    fetchData();

    // Cleanup function to cancel subsciprtion to dispatch and avoid memory leak
    return () => {
      // Set to false when the component is unmounted
      isMounted = false;
    };
  }, [dispatch, selectedTissue, tissueList, id, setError]);

  if (!loaded) {
    return <h1>Loading...</h1>;
  } else {
    return (
      <Component
        selectedTissue={selectedTissue}
        tissueList={tissueList}
        id={id}
        user={user}
      />
    );
  }
};
